import Aux from "../../../../hoc/Auxiliary";
import DataCollectionDetailsButton from "../DetailsButton/DetailsButton";
import {updateProperty} from "../../../../api/utils/conditions-utils";
import {Button} from "primereact/button";
import {isAuthorized} from "../../../../api/authorization/authorization-service";
import React, {useCallback} from "react";
import {confirmDialog} from "primereact/confirmdialog";
import {deleteDataCollectionDraft} from "../../../../api/dataCollection/dataCollection-service";
import {showSuccess} from "../../../../api/notification/ToastManager";
import classes from "../DataCollectionList.module.css";
import classesP from "../../DataCollectionCreator/ParticipantsSetting/ParticipantsSetting.module.css";

const ActionColumnDcInProgress = ({rowData, setDcListInProgress, dcListInProgress}) => {

    const handleDeleteResponse = (response, dcId) => {
        if (response.status !== 200 || response.data.content === -1) {
            return;
        }

        const updatedList = dcListInProgress.filter(item => item.id !== dcId);
        setDcListInProgress(updatedList);
        showSuccess("Data collection deleted successfully!");
    }

    const deleteDraft = (dcId, dcName) => {
        deleteDataCollectionDraft({ dcId, dcName })
            .then((response) => handleDeleteResponse (response, dcId))
            .catch((error) => {
                console.error("Error deleting data collection:", error);
            });
    };

    const confirmDeleteDc = (dcId, dcName) => {
        confirmDialog({
            message: 'Are you sure you want to delete data collection in progress "' + dcName + '" ?',
            header: 'Confirmation',
            accept: () => deleteDraft (dcId, dcName),
            reject: () => {
            },
            icon: 'pi pi-exclamation-triangle',
            appendTo: "self",
            acceptClassName: `${classes.buttons} ${classesP.actionBtn}`,
            rejectClassName: `${classes.buttons} ${classesP.actionBtn}`

        });
    }


    return (
        <Aux>
            <div className=" grid p-0 ">

                <div className=" col p-0 m-0 flex align-items-center justify-content-center">
                    {
                        updateProperty(isAuthorized("AR08"), <Button icon=" pi pi-trash"
                                                                     tooltip=" Delete data collection"
                                                                     tooltipOptions={{
                                                                         position: 'top',
                                                                         showOnDisabled: true
                                                                     }}
                                                                     className=" p-button-rounded-sm p-button-text"
                                                                     onClick={() => confirmDeleteDc(rowData.id, rowData.name)}
                                                                     style={{
                                                                         height: '0.5rem',
                                                                         width: '1.5rem',
                                                                         color: '#487c84'
                                                                     }}/>, null)
                    }
                </div>

                <div>
                    <DataCollectionDetailsButton rowData={rowData}/>
                </div>
            </div>


        </Aux>
    )


}
export default ActionColumnDcInProgress;
